import React, { useEffect, useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import Table from "react-bootstrap/Table";
import Dettagli from "./DettagliManVen";
import axios from "axios";

function WithHeaderStyledExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [quantityOrdered2023, setQuantityOrdered2023] = useState(0);
  const [quantityOrdered2024, setQuantityOrdered2024] = useState(0);
  const [percentuale, setPercentuale] = useState("");

  const [mancataVenditaMedia, setMancataVenditaMedia] = useState({});
  const [mancataVenditaAttuale, setMancataVenditaAttuale] = useState({});
  const [percentualeValore, setPercentualeValore] = useState("");
  const [percentualeQta, setPercentualeQta] = useState("");
  const [percentualeNumCli, setPercentualeNumCli] = useState("");

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const containerRef = useRef(null);

  // Funzione per formattare numeri in euro
  const formatToEuro = (amount) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount || 0);
  };

  // Calcola l’intervallo date per la didascalia
  const getDateRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    const lastYear = currentYear - 1;

    const pad = (n) => (n < 10 ? "0" + n : n);

    const formattedCurrentMonth = pad(currentMonth);
    const formattedToday = pad(today.getDate());

    const currentDateRange = `01/${formattedCurrentMonth}/${currentYear} - ${formattedToday}/${formattedCurrentMonth}/${currentYear}`;
    const lastYearDateRange = `01/${formattedCurrentMonth}/${lastYear} - ${formattedToday}/${formattedCurrentMonth}/${lastYear}`;

    return { currentDateRange, lastYearDateRange };
  };

  const { currentDateRange, lastYearDateRange } = getDateRange();

  // 🟢 Primo fetch: dati vendite annuali
  useEffect(() => {
    const fetchVendite = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mese } = res.data.TP;

        const entry2023 = mese.find((entry) => entry.anno === "2025");
        const entry2024 = mese.find((entry) => entry.anno === "2026");

        if (entry2023) setQuantityOrdered2023(entry2023.valore_ordinato);
        if (entry2024) setQuantityOrdered2024(entry2024.valore_ordinato);

        if (entry2023 && entry2024) {
          const percentualChange =
            ((entry2024.valore_ordinato - entry2023.valore_ordinato) /
              entry2023.valore_ordinato) *
            100;
          setPercentuale(percentualChange.toFixed(2));
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Errore nel caricamento dati vendite:", error);
        setIsError(true);
      }
    };

    fetchVendite();
  }, []);

  // 🟢 Secondo fetch: dati mancata vendita (eseguito UNA volta, non in loop)
  useEffect(() => {
    const fetchMancataVendita = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mancata_vendita } = res.data.TP;

        if (mancata_vendita) {
          setMancataVenditaMedia(mancata_vendita.media);
          setMancataVenditaAttuale(mancata_vendita.attuale);

          const diffValore =
            mancata_vendita.attuale.valore - mancata_vendita.media.valore;
          const percValore = (diffValore / mancata_vendita.media.valore) * 100;
          setPercentualeValore(percValore.toFixed(2));

          const diffQta =
            mancata_vendita.attuale.qta - mancata_vendita.media.qta;
          const percQta = (diffQta / mancata_vendita.media.qta) * 100;
          setPercentualeQta(percQta.toFixed(2));

          const diffCli =
            mancata_vendita.attuale.num_cli - mancata_vendita.media.num_cli;
          const percCli = (diffCli / mancata_vendita.media.num_cli) * 100;
          setPercentualeNumCli(percCli.toFixed(2));
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Errore nel caricamento mancata vendita:", error);
        setIsError(true);
      }
    };

    fetchMancataVendita();
  }, []); // 👈 Nessuna dipendenza → nessun loop

  const totalOrders =
    parseFloat(quantityOrdered2023) + parseFloat(quantityOrdered2024);

  return (
    <>
      <Card
        style={{
          cursor: "pointer",
          borderRadius: "10px",
          border: "1px solid rgb(200, 200, 200)",
        }}
        className="hover-effect cs"
        onClick={handleShowModal}
      >
        <Card.Body
          className="d-flex flex-column align-items-center justify-content-center text-center p-2"
        >
          <p className="text-title p-1">
            DETTAGLI VENDITE
          </p>

          <p style={{ fontSize: "0.6em" }} className="fw-bold mb-1">
            Confronto al periodo che va dal {currentDateRange} al{" "}
            {lastYearDateRange}
          </p>

          <div className="d-flex flex-column align-items-center justify-content-center">
            <h5 className="fw-bold mx-3" style={{ fontSize: "1.1em" }}>
              TOTALE 2025: {formatToEuro(quantityOrdered2023)}
            </h5>
            <h5 className="fw-bold mx-3" style={{ fontSize: "1.1em" }}>
              TOTALE 2026: {formatToEuro(quantityOrdered2024)}
            </h5>

            <p
              className="fw-bold mb-2"
              style={{
                fontSize: "0.6em",
                margin: 0,
                borderBottom: "1px solid black",
                width: "100%",
              }}
            >
              Confronto mensile annuale: {percentuale}%
              {percentuale !== "" && (
                <>
                  {parseFloat(percentuale) < 0 ? (
                    <FaArrowTrendDown style={{ color: "red" }} />
                  ) : (
                    <FaArrowTrendUp style={{ color: "green" }} />
                  )}
                </>
              )}
            </p>
          </div>

          <div className="w-100">
            <Table
              className="text-center"
              style={{ width: "100%", fontWeight: "bold", fontSize: "12px" }}
            >
              <thead>
                <tr>
                  <th className="text-start">Mancata vendita</th>
                  <th>Media mensile</th>
                  <th className="text-end">Trend</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "start" }}>
                    {formatToEuro(mancataVenditaAttuale.valore)}
                  </td>
                  <td>{formatToEuro(mancataVenditaMedia.valore)}</td>
                  <td style={{ textAlign: "end" }}>
                    {percentualeValore}%{" "}
                    {percentualeValore > 0 ? (
                      <FaArrowTrendUp style={{ color: "red" }} />
                    ) : (
                      <FaArrowTrendDown style={{ color: "green" }} />
                    )}
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "start" }}>
                    Cli: {mancataVenditaAttuale.num_cli}
                  </td>
                  <td>Cli: {mancataVenditaMedia.num_cli}</td>
                  <td style={{ textAlign: "end" }}>
                    {percentualeNumCli}%{" "}
                    {percentualeNumCli > 0 ? (
                      <FaArrowTrendUp style={{ color: "red" }} />
                    ) : (
                      <FaArrowTrendDown style={{ color: "green" }} />
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* Modale dettagli */}
      <Dettagli showModal={showModal} handleCloseModal={handleCloseModal} />
    </>
  );
}

export default WithHeaderStyledExample;
